import { render, staticRenderFns } from "./StudyDefinitionAdmin.vue?vue&type=template&id=c9bac29e"
import script from "./StudyDefinitionAdmin.vue?vue&type=script&lang=ts"
export * from "./StudyDefinitionAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports